export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40616cc29949a11ab87075fa6658993807c05959fc&name=revalidateCommunity!'